export default "Documentation > Beacon Network UI > Querying the UI\n\nNetwork UI\nQueries\nComing soon...\n";